import { render, staticRenderFns } from "./ProjectsTableWrapper.vue?vue&type=template&id=1f8b743f&scoped=true"
import script from "./ProjectsTableWrapper.vue?vue&type=script&lang=ts"
export * from "./ProjectsTableWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsTableWrapper.vue?vue&type=style&index=0&id=1f8b743f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b743f",
  null
  
)

export default component.exports